import React, { useState } from 'react';
import { UseFormRegister } from 'react-hook-form';

import TooltipIcon from '../TooltipIcon';
import Tooltip from '../Tooltip';

import IInputs from '../../../interfaces/IInputs';
import IRules from '../../../interfaces/IRules';
import './Textarea.sass';

interface Props {
	inputName:
		| 'additionalInfo'
		| 'info'
		| 'bio'
		| 'talkKeyPoints'
		| 'talkKeyPoints2'
		| 'talkKeyPoints3'
		| 'talkDescription'
		| 'talkDescription2'
		| 'talkDescription3'
		| 'accidentReport';
	placeholder?: string;
	label: string;
	required?: boolean;
	register: UseFormRegister<IInputs>;
	rules?: IRules;
	invalid?: boolean;
	valid?: boolean;
	hasTooltip?: string;
	id?: string;
	content?: any;
}

function Textarea({
	inputName,
	placeholder,
	label,
	required,
	register,
	rules,
	invalid,
	valid,
	hasTooltip,
	content,
}: Props) {
	const [active, setActive] = useState<boolean>(false);

	return (
		<div className="textarea-row">
			<label htmlFor={inputName} className="form-label">
				{label}
				{required && ' *'}
				{hasTooltip && hasTooltip !== '' && (
					<TooltipIcon
						tooltipValue={hasTooltip}
						setActive={setActive}
						active={active}
					/>
				)}
			</label>
			<textarea
				autoComplete="disabled"
				className={`textarea-default${invalid ? ' invalid' : ''}${
					valid ? ' valid' : ''
				}`}
				id={inputName}
				placeholder={placeholder}
				{...register(inputName, rules)}
			/>

			<Tooltip id="bio" content={content} active={active} />
		</div>
	);
}

Textarea.defaultProps = {
	hasTooltip: false,
	placeholder: '',
	required: false,
	rules: {},
	invalid: false,
	valid: false,
};
export default Textarea;
